<div *ngIf="!!title" class="shared-sidebar-title-cell">
  <div class="shared-sidebar-title">{{ title }}</div>
  <div *ngIf="!!subtitle" class="shared-sidebar-subtitle" [ngClass]="{ pulse: pulse }">{{ subtitle }}</div>
</div>
